import { UUID_REGEX } from '@/lib/api/core'

/** Filter to document UUIDs accepted by POST /api/documents/search boost params. */
export function filterUuidIdsForSearch(ids: string[] | undefined): string[] | undefined {
  if (!ids?.length) return undefined
  const filtered = ids.filter((id) => UUID_REGEX.test(id))
  return filtered.length > 0 ? filtered : undefined
}

/** Folder paths and other non-UUID reference ids must not be sent as openTabIds. */
export function filterOpenTabIdsForSearch(ids: string[] | undefined): string[] | undefined {
  return filterUuidIdsForSearch(ids)
}

/** organization/workspace scope must be org UUIDs (stale localStorage can hold slugs). */
export function filterWorkspaceIdsForSearch(ids: string[] | undefined): string[] | undefined {
  return filterUuidIdsForSearch(ids)
}
